import { GET, POST } from "@/utils/http";

const ADMIN_BASE_URI = "/customer-inquiries";

export const ContactService = {
  getDetail(contactId: string): Promise<ContactDetail | null | undefined> {
    return GET<ContactDetail>(`${ADMIN_BASE_URI}/detail/${contactId}`);
  },
  search(
    request: SearchContactRequest,
  ): Promise<SearchContactResponse | null | undefined> {
    return POST<SearchContactResponse>(`${ADMIN_BASE_URI}/search`, request);
  },
  setState(params: {
    contactId: number;
    state: number;
    remark?: string;
  }): Promise<SearchContactResponse | null | undefined> {
    return GET<SearchContactResponse>(
      `${ADMIN_BASE_URI}/state`,
      { params },
      true,
    );
  },
  export(data?: any) {
    return POST<Blob>(`${ADMIN_BASE_URI}/export`, data, {
      responseType: "blob",
    });
  },
};
